import { render, staticRenderFns } from "./ReportBuilderPdf.vue?vue&type=template&id=2032c5ea"
import script from "./ReportBuilderPdf.vue?vue&type=script&lang=js"
export * from "./ReportBuilderPdf.vue?vue&type=script&lang=js"
import style0 from "./ReportBuilderPdf.vue?vue&type=style&index=0&id=2032c5ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports